/* eslint-disable max-len */

import { defineMessages } from 'react-intl';

export default defineMessages({
  errorFlash: {
    id: 'create.errorFlash',
    defaultMessage:
      '{errorCount, plural, one {There is {errorCount} error on this page. Please review the highlighted fields before moving to the next step.} other {There are {errorCount} errors on this page. Please review the highlighted fields before moving to the next step.}}',
  },
  errorFlashModal: {
    id: 'create.errorFlashModal',
    defaultMessage:
      '{errorCount, plural, one {There is {errorCount} error on this page. Please review the highlighted fields.} other {There are {errorCount} errors on this page. Please review the highlighted fields.}}',
  },
  errorRequired: {
    id: 'create.errorRequired',
    defaultMessage: 'This field is required',
  },
  blacklistedCountryError: {
    id: 'create.blacklistedCountryError',
    defaultMessage: 'Event location is not supported',
  },
  cannotUpdateFanReminderInBufferPeriod: {
    id: 'create.cannotUpdateFanReminderInBufferPeriod',
    defaultMessage: 'Remind Me cannot be updated within 24 hours of when they\'re scheduled to send.'
  },
  scheduleEarlierThanCurrentError: {
    id: 'create.scheduleEarlierThanCurrentError',
    defaultMessage: 'Scheduled publish time should be later than current time',
  },
  errorNetwork: {
    id: 'create.errorNetwork',
    defaultMessage: 'An error occurred, try again later',
  },
  errorCannotCreate: {
    id: "create.errorCannotCreate",
    defaultMessage: "Your event could not be created, contact support"
  },
  fanReminderTiming: {
    id: "create.fanReminderTiming",
    defaultMessage: "Remind Me timing must be at least 24 hours before the ticket start time."
  },
  ticketsErrorNoRates: {
    id: 'create.ticket.ticketsErrorNoRates',
    defaultMessage: 'At least one ticket type needs to be added.',
  },
  errorNoSchedules: {
    id: 'create.errorNoSchedules',
    defaultMessage: 'At least one timeslot needs to be added.',
  },
  pastStartTimeError: {
    id: 'create.pastStartTimeError',
    defaultMessage: 'Please adjust the highlighted fields. Event start time needs to be in the future.',
  },
  intervalCollision: {
    id: 'manage.schedules.intervalCollision',
    defaultMessage: 'One timeslot with the same start time and duration already exists.',
  },
  intervalError: {
    id: 'manage.schedules.intervalError',
    defaultMessage: 'There is a problem with the interval.',
  },
  repetitionErrorEndDate: {
    id: 'manage.schedules.repetitionErrorEndDate',
    defaultMessage: 'There is a problem with the end date.',
  },
  repetitionErrorWeekdayAvailability: {
    id: 'manage.schedules.repetitionErrorWeekdayAvailability',
    defaultMessage: 'There is a problem with weekday availability.',
  },
  maxRateCustomizationError: {
    id: 'rateCustomizations.maxError',
    defaultMessage: "The changes you are trying to make exceed the maximum number allowed. In order to continue, please decrease the amount of changes. \nNote that you are able to make additional changes once changed timeslots end."
  },
  maxAipLimitError: {
    id: "rateCustomizations.maxAipLimitError",
    defaultMessage: "The price changes you're trying to make exceed the maximum number of price points allowed. Decrease the amount of price points in order to continue."
  },
  deleteSoldAddOn: {
    id: "delete.soldAddons",
    defaultMessage: "You cannot delete an add-on that has already been sold."
  },
  priceGuardrailError: {
    id: "rateCustomizations.priceGuardrailError",
    defaultMessage: "Additional fees exceed 50% limitation",
  }
});

/* eslint-enable max-len */
